import { createColumnHelper } from '@tanstack/react-table'
import { formatNumber } from '../../utils/formatNumber'
import { NavLink } from 'react-router-dom'
import { ReportColumnHeader } from '../ReportColumnHeader'
import type { FleetReportDetails } from '../../../../../types'

export default function fleetReportDetailsTableData() {
  const settings = { digits: { min: 0, max: 0 }, prefix: 'kr ' }

  const columnHelper = createColumnHelper<FleetReportDetails>()
  return [
    columnHelper.accessor('description', {
      id: 'description',
      header: () => <ReportColumnHeader title="Kostnadstype" />,
      cell: (row) => row.getValue() || '',
      enableSorting: false,
    }),
    columnHelper.accessor('fixedCostsTerm', {
      id: 'fixedCostsTerm',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Sum faste kostnader',
      },
      header: () => <ReportColumnHeader title="Faste kostnader" />,
      cell: (row) => formatNumber(row.getValue(), settings),
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + (Number(row.getValue('fixedCostsTerm')) || 0), 0)
        return formatNumber(total, settings)
      },
      enableSorting: false,
    }),
    columnHelper.accessor('nonFixedCostsTerm', {
      id: 'nonFixedCostsTerm',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Sum variable kostnader',
      },
      header: () => <ReportColumnHeader title="Variable kostnader" />,
      cell: (row) => formatNumber(row.getValue(), settings),
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + (Number(row.getValue('nonFixedCostsTerm')) || 0), 0)
        return formatNumber(total, settings)
      },
      enableSorting: false,
    }),
    columnHelper.accessor('totalTerm', {
      id: 'totalTerm',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Total sum',
      },
      header: () => <ReportColumnHeader title="Sum" />,
      cell: ({ row, getValue }) => {
        if (getValue() === 0) return formatNumber(getValue(), settings)
        return (
          <NavLink
            to={`/reports/fleet/expense/${row.original.accountNo}/${row.original.itemNo}?type=month`}
            className="text-blue-600 hover:underline"
          >
            {formatNumber(getValue(), settings)}
          </NavLink>
        )
      },
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + (Number(row.getValue('totalTerm')) || 0), 0)
        return formatNumber(total, settings)
      },
      enableSorting: false,
    }),
    columnHelper.accessor('totalYear', {
      id: 'totalYear',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Total hittil i år',
      },
      header: () => <ReportColumnHeader title="Hittil i år" />,
      cell: ({ row, getValue }) => {
        if (getValue() === 0) return formatNumber(getValue(), settings)
        return (
          <NavLink
            to={`/reports/fleet/expense/${row.original.accountNo}/${row.original.itemNo}?type=year`}
            className="text-blue-600 hover:underline"
          >
            {formatNumber(getValue(), settings)}
          </NavLink>
        )
      },
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + (Number(row.getValue('totalYear')) || 0), 0)
        return formatNumber(total, settings)
      },
      enableSorting: false,
    }),
    columnHelper.accessor('totalContract', {
      id: 'totalContract',
      meta: {
        alignmentType: 'right',
        mobileFooterLabel: 'Total hittil i kontrakt',
      },
      header: () => <ReportColumnHeader title="Hittil i kontrakt" />,
      cell: (row) => formatNumber(row.getValue(), settings),
      footer: ({ table }) => {
        const total = table
          .getFilteredRowModel()
          .rows.reduce((sum, row) => sum + (Number(row.getValue('totalContract')) || 0), 0)
        return formatNumber(total, settings)
      },
      enableSorting: false,
    }),
  ]
}
